import React, { useState } from "react";

interface PhaseAnalyticsTabProps {
  data: any;
}

export default function PhaseAnalyticsTab({ data }: PhaseAnalyticsTabProps) {
  const [selectedPhase, setSelectedPhase] = useState<string>("pre-class");

  if (!data.phases) {
    return <div className="alert alert-info">No phase data available</div>;
  }

  const phases = data.phases;
  const currentPhase = phases[selectedPhase];

  const renderStars = (score: number) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span key={i} className={i <= score ? "star filled" : "star"}>
          ⭐
        </span>
      );
    }
    return stars;
  };

  return (
    <div className="phase-analytics-tab">
      {/* Phase Selector */}
      <div className="phase-selector">
        <button
          className={`phase-btn ${selectedPhase === "pre-class" ? "active" : ""}`}
          onClick={() => setSelectedPhase("pre-class")}
        >
          📖 Pre-Class
        </button>
        <button
          className={`phase-btn ${selectedPhase === "in-class" ? "active" : ""}`}
          onClick={() => setSelectedPhase("in-class")}
        >
          👩‍🏫 In-Class
        </button>
        <button
          className={`phase-btn ${selectedPhase === "post-class" ? "active" : ""}`}
          onClick={() => setSelectedPhase("post-class")}
        >
          📝 Post-Class
        </button>
      </div>

      {currentPhase ? (
        <>
          {/* Phase Overview */}
          <div className="analytics-card">
            <h5>
              {selectedPhase === "pre-class"
                ? "📖 Pre-Class"
                : selectedPhase === "in-class"
                  ? "👩‍🏫 In-Class"
                  : "📝 Post-Class"}{" "}
              Overview
            </h5>
            <div className="metrics-grid">
              <div className="metric-card">
                <div className="metric-label">Total Resources</div>
                <div className="metric-value">{currentPhase.resourceCount || 0}</div>
              </div>
              <div className="metric-card">
                <div className="metric-label">Total Views</div>
                <div className="metric-value">{currentPhase.totalViews || 0}</div>
              </div>
              <div className="metric-card">
                <div className="metric-label">Unique Students</div>
                <div className="metric-value">{currentPhase.uniqueStudents || 0}</div>
              </div>
              <div className="metric-card">
                <div className="metric-label">Avg Time Spent</div>
                <div className="metric-value">
                  {Math.round(currentPhase.averageTimeSpent || 0)} min
                </div>
              </div>
              <div className="metric-card">
                <div className="metric-label">Completion Rate</div>
                <div className="metric-value">
                  {Math.round(currentPhase.completionRate || 0)}%
                </div>
              </div>
            </div>
          </div>

          {/* Resources Table */}
          {currentPhase.resources && currentPhase.resources.length > 0 ? (
            <div className="analytics-card">
              <h5>📚 Resources</h5>
              <div className="table-responsive">
                <table className="table table-hover analytics-table">
                  <thead>
                    <tr>
                      <th>Resource Name</th>
                      <th>Type</th>
                      <th>Views</th>
                      <th>Students</th>
                      <th>Avg Time</th>
                      <th>Completion</th>
                      <th>Revisit Rate</th>
                      <th>Effectiveness</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPhase.resources.map((resource: any, index: number) => (
                      <tr key={index}>
                        <td>
                          <strong>{resource.name || "Untitled Resource"}</strong>
                        </td>
                        <td>
                          <span className="type-badge">
                            {resource.type || "Unknown"}
                          </span>
                        </td>
                        <td>{resource.totalViews || 0}</td>
                        <td>{resource.uniqueStudents || 0}</td>
                        <td>{Math.round(resource.averageTimeSpent || 0)} min</td>
                        <td>
                          <div className="progress-container">
                            <div
                              className="progress-bar"
                              style={{
                                width: `${Math.round(resource.completionRate || 0)}%`,
                              }}
                            />
                            <span className="progress-label">
                              {Math.round(resource.completionRate || 0)}%
                            </span>
                          </div>
                        </td>
                        <td>{Math.round(resource.revisitRate || 0)}%</td>
                        <td>
                          <div className="effectiveness-rating">
                            {renderStars(resource.effectivenessScore || 0)}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="analytics-card">
              <div className="alert alert-info">
                No resources found for this phase
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="alert alert-warning">
          No data available for {selectedPhase} phase
        </div>
      )}
    </div>
  );
}
